import {Router} from '@angular/router';
import {ClienteService} from 'app/service/cliente/cliente.service';
import {ClienteModel} from 'app/model/cliente/cliente.model';
import {AuthenticationService} from '@alfresco/adf-core';
import {SolicitacaoService} from './../../../service/solicitacao/solicitacao.service';
import {Component, OnInit, ViewChild} from '@angular/core';
import {MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition} from '@angular/material/snack-bar';
import {MatTableDataSource, MatPaginator, MatSort} from '@angular/material';
import * as CryptoJS from 'crypto-js';
import {MatDialog} from '@angular/material/dialog';
import {CaixaService} from 'app/service/caixa/caixa.service';
import * as JSPM from 'jsprintmanager';
import {DialogConfirmComponent} from 'app/components/dialog/dialog-confirm/dialog-confirm.component';

@Component({
  selector: 'app-listar-solicitacoes',
  templateUrl: './listar-solicitacoes.component.html',
  styleUrls: ['./listar-solicitacoes.component.scss']
})
export class ListarSolicitacoesComponent implements OnInit {

  public clientes: ClienteModel[];
  public solicitacoes: any[] = [];
  public clientePesquisado;
  public idSolicitacoes: any[] = [];
  public buttonRelatorio = true;
  public loading = true;
  public inputPesquisa = false;
  dataSource = new MatTableDataSource<any[]>([]);
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  displayedColumns = ['cod', 'tpSolic', 'respAbertura', 'area', 'centroCusto',
    'dataAbertura', 'dataFechamento', 'dadosAdicionais', 'status', 'acoes'];
  horizontalPosition: MatSnackBarHorizontalPosition = 'right';
  verticalPosition: MatSnackBarVerticalPosition = 'top';
  adm = false;
  acervo = false;
  solicitacao = true;
  solicitacaoUnica;
  caixasSolicitacoes = [];
  etiquetas;
  printers: string[];
  selectedPrinter: any;
  isDefaultPrinterSelected = false;
  clienteSelecionado;


  constructor(
    private dialog: MatDialog,
    private caixaService: CaixaService,
    private authService: AuthenticationService,
    private _snackBar: MatSnackBar,
    private solicitacaoService: SolicitacaoService,
    private router: Router,
    private clienteService: ClienteService) {
  }

  ngOnInit() {
    this.listarClientesUsuario();

    // WebSocket settings
    /*
    JSPM.JSPrintManager.auto_reconnect = true;
    JSPM.JSPrintManager.start();
    JSPM.JSPrintManager.WS.onStatusChanged = () => {
        if (this.jspmWSStatus()) {
            // get client installed printers
            JSPM.JSPrintManager.getPrinters().then((myPrinters: string[]) => {
              this.printers = myPrinters;
              this.printers.map(element => {
                if (element === 'Microsoft XPS Document Writer') {
                  this.selectedPrinter = element;
                }
              });
              console.log(this.printers);
              // this.selectedPrinter = this.printers[0];
            });
        }
    };*/
  }

  deleteSolicitacao(solicitacaoId: number) {
    const dialogRef = this.dialog.open(DialogConfirmComponent, {
      data: {name: 'Deseja cancelar esta solicitação ?', from: 'listar-solicitacoes.component.ts'}
    });
    dialogRef.afterClosed().subscribe((confirmed: any) => {
      console.log(confirmed.apagar);
      if (confirmed.apagar === true) {
        this.cancelarSolic(solicitacaoId);
      }
    });
  }

  excluirSolic(id: number) {
    this.solicitacaoService.excluirSolicitacao(id).subscribe(() => {
      this.openSnackBarSuccess('Solicitação excluída com sucesso !');
      this.getSolicitacoes(this.clientePesquisado);
    }, err => {
      console.error(err);
      this.openSnackBarError('Não é possível excluir a solicitação, provavelmente ela já está relacionada a outro registro no sistema.');
    })
  }

  cancelarSolic(id: number) {
    this.solicitacaoService.cancelarSolicitacao(id).subscribe(() => {
      this.openSnackBarSuccess('Solicitação cancelada com sucesso !');
      this.getSolicitacoes(this.clientePesquisado);
    }, err => {
      console.error(err);
      this.openSnackBarError('Não é possível cancelar a solicitação !');
    })
  }

  getSolicitacoes(clienteId) {
    this.loading = true;
    //this.solicitacaoService.getSolicitacoesCliente(clienteId).subscribe(data => {
      this.solicitacaoService.getSolicitacoesClienteInterface(clienteId).subscribe(data => {
      if (data.length === 0) {
        this.openSnackBarError('Nenhuma solicitação encontrada !');
        this.solicitacoes = data;
        this.dataSource = new MatTableDataSource(data);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.inputPesquisa = true;
        this.loading = false;
        this.inputPesquisa = false;
      } else {
        this.solicitacoes = data;
        this.dataSource = new MatTableDataSource(data);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.inputPesquisa = true;
        this.loading = false;
      }
    }, err => {
      console.error(err);
      this.loading = false;
    });
  }

  getSolicitacao(solicitacaoId) {
    this.solicitacaoService.getSolicitacao(solicitacaoId).subscribe(data => {
      console.log(data);
      this.solicitacaoUnica = data;
      this.loading = false;
      this.imprimirEtiquetas(this.solicitacaoUnica.id);
    }, err => {
      console.error(err);
    });
  }

  imprimirEtiquetas(solicitacaoId) {
    this.loading = true;
    this.caixasSolicitacoes = [];
    console.log(this.solicitacaoUnica);
    this.solicitacaoUnica.caixas.map(element => {
      this.caixasSolicitacoes.push(element.id);
    });
    console.log(this.caixasSolicitacoes);
    this.caixaService.downloadEtiquetas(this.caixasSolicitacoes).subscribe(data => {
      this.etiquetas = data;
      this.loading = false;
      // this.doPrintZPL(data);
      this.download(data, solicitacaoId);
    }, err => {
      console.error(err);
      this.loading = false;
      this.openSnackBarError('Selecione apenas caixas com endereço definido !');
    });
  }

  download(text, cod) {
    var date = new Date();
    var dateFormat = date.toLocaleDateString('pt-BR');
    var nameFile = `etiquetas_caixas_solic_${cod}___` + dateFormat + '.txt';
    var element = document.createElement('a');
    element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
    element.setAttribute('download', nameFile);

    element.style.display = 'none';
    document.body.appendChild(element);

    element.click();

    document.body.removeChild(element);
  }

  relatorioSolicitacao(solicitacaoId) {
    console.log('Aqui');
    const solicitacaoIdRecebida = encodeURIComponent(CryptoJS.AES.encrypt(JSON.stringify(solicitacaoId), 'pcdoc').toString());
    window.open(`relatorio-solicitacao/${solicitacaoIdRecebida}`,
      '_blank',
      'location=yes,height=570,width=520,scrollbars=yes,status=yes'); // Open new window
  }

  relacotioCaixasRealocadas(solicitacaoId) {
    console.log('Aqui');
    const solicitacaoIdRecebida = encodeURIComponent(CryptoJS.AES.encrypt(JSON.stringify(solicitacaoId), 'pcdoc').toString());
    window.open(`relatorio-solicitacao-realocacao/${solicitacaoIdRecebida}`,
      '_blank',
      'location=yes,height=570,width=520,scrollbars=yes,status=yes'); // Open new window
  }

  aplicarFiltros(filter: string) {
    filter = filter.trim();
    filter = filter.toLowerCase();
    this.dataSource.filter = filter;
  }

  pesquisaAvancanda() {
    const idCliente = encodeURIComponent(CryptoJS.AES.encrypt(JSON.stringify(this.clientePesquisado), 'pcdoc').toString());
    this.router.navigate(['pesquisa-avancada-solicitacao', idCliente]);
  }

  listarClientesUsuario() {
    this.clienteService.getPageClientesUsuario().subscribe(data => {
      this.clientes = data.content;
      this.loading = false;
    }, err => {
      console.error(err);
      this.loading = false;
    });
  }

  goToAddCaixa(id) {
    this.loading = true;
    const idCrypt = encodeURIComponent(CryptoJS.AES.encrypt(JSON.stringify(id), 'pcdoc').toString());
    this.router.navigate(['/solicitacao', idCrypt]);
  }

  goToProcessamento(id) {
    this.router.navigate(['/processar-solicitacao/' + id]);
  }

  onSearch() {
    let numberSelected = (<HTMLSelectElement>document.getElementById('selectCliente')).options.selectedIndex;
    this.clienteSelecionado = (<HTMLSelectElement>document.getElementById('selectCliente')).options[numberSelected].innerText;
    let value = (<HTMLSelectElement>document.getElementById('selectCliente')).value;
    this.clientePesquisado = parseInt(value);
    if (parseInt(value) == 0) {
      this.openSnackBarError('Nenhum Cliente selecionado !');
      return null;
    }
    this.getSolicitacoes(parseInt(value));
  }

  checkAll(e) {
    var pageIndex = this.paginator.pageIndex;
    var pageSize = this.paginator.pageSize;
    var lengthData = this.paginator.length;
    if (e === true) {
      for (let i = pageIndex * pageSize; i < (pageIndex * pageSize) + pageSize && i < lengthData; i++) {
        this.dataSource.data[i]['isSelected'] = true;
        this.idSolicitacoes.push(this.dataSource.data[i]['id']);
        this.buttonRelatorio = false;
      }
    } else {
      for (let i = pageIndex * pageSize; i < (pageIndex * pageSize) + pageSize && i < lengthData; i++) {
        this.dataSource.data[i]['isSelected'] = false;
        var id = this.dataSource.data[i]['id'];
        let index = this.idSolicitacoes.indexOf(id);
        this.idSolicitacoes.splice(index, 1);
        this.buttonRelatorio = true;
      }
    }
  }

  // SnackBares
  openSnackBarSuccess(message: string) {
    this._snackBar.open(message, '', {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 4000,
      panelClass: ['success-snackbar']
    });
  }

  openSnackBarError(message: string) {
    this._snackBar.open(message, '', {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 3000,
      panelClass: ['error-snackbar']
    });
  }

  // Check JSPM WebSocket status
  jspmWSStatus() {
    if (JSPM.JSPrintManager.websocket_status === JSPM.WSStatus.Open) {
      return true;
    } else if (JSPM.JSPrintManager.websocket_status === JSPM.WSStatus.Closed) {
      //alert('JSPrintManager (JSPM) is not installed or not running! Download JSPM Client App from https://neodynamic.com/downloads/jspm');
      return false;
    } else if (JSPM.JSPrintManager.websocket_status === JSPM.WSStatus.Blocked) {
      alert('JSPM has blocked this website!');
      return false;
    }
  }

  // Do Zebra ZPL printing...
  doPrintZPL(text) {
    if (this.jspmWSStatus()) {
      // Create a ClientPrintJob
      const cpj = new JSPM.ClientPrintJob();
      // Set Printer type (Refer to the help, there many of them!)
      //https://www.neodynamic.com/Products/Help/JSPrintManager4.0/articles/jsprintmanager.html#client-printer-types
      if (this.isDefaultPrinterSelected) {
        cpj.clientPrinter = new JSPM.DefaultPrinter();
      } else {
        cpj.clientPrinter = new JSPM.InstalledPrinter(this.selectedPrinter);
      }

      // Set content to print...
      //Create Zebra ZPL commands for sample label
      var cmds = text;
      cpj.printerCommands = cmds;
      // Send print job to printer!
      cpj.sendToClient();
    }
  }

}



// WEBPACK FOOTER //
// /app/src/app/components/solicitacao/listar-solicitacoes/listar-solicitacoes.component.ts